import '../../scss/pages/index.scss';
import './checkWebpSupport';

import './checkLanguage';
import './saveClickId';
import './saveCookie';

import { initHeader } from './header';
import { initHero } from './hero';
import { initAbout } from './about';
import { initScroll } from './utils';
import { initFeatures } from './features';
import { initReviews } from './reviews';
import { initPartners } from './partners';
import { initClients } from './clients';
import { initContacts } from './contacts';
import { initCookiesBar } from "../common/cookies-bar";
import { initCookieHubBar } from "../common/cookiehub-bar";

const initCookiesBars = () => {
    initCookieHubBar();
    initCookiesBar();
}

document.addEventListener('DOMContentLoaded', function(){
    initHero();
    initAbout();
    initHeader();
    initScroll();
    initFeatures();
    setTimeout(initReviews, 100);
    setTimeout(initPartners, 200);
    initClients();
    initContacts();
    setTimeout(initCookiesBars, 7000);
});
